/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';

export const ArrowContainer = styled.div<{
  isOpen: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  isLoading?: boolean;
  hasError?: boolean;
}>`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transform-origin: center;
  transition: transform 0.35s;

  ${({ theme, disabled, readOnly, hasError, isLoading }) => css`
    cursor: ${disabled || readOnly ? 'auto' : 'pointer'};

    & > * {
      cursor: ${disabled || readOnly ? 'auto' : 'pointer'};
    }
  `}
`;
